module.exports = __webpack_public_path__ + "8daf5cdb38bec8afa6c4d479a6b080f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/trainingarticle_1.jpg
// module id = 304
// module chunks = 0